module.exports = __webpack_public_path__ + "img/p1.8f700151.png";